import { useState } from "react";
import { api } from "./api";

// Shared media upload hook — posts a file to /upload and returns its URL.
export function useUpload() {
  const [uploading, setUploading] = useState(false);
  const upload = async (file) => {
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      return data.url;
    } finally { setUploading(false); }
  };
  return { upload, uploading };
}
